import React from 'react'
import { VEC_ICON_NAME } from '../../icons/constants';
import Icons from '../../icons/Icons';
import styles from "./Checkbox.styles"
import "../directcss/Checkbox.scss"

const Checkbox = ({ checked = false, onChangeCb, name = "", iconName = VEC_ICON_NAME.CHECKBOX_ICON, containerStyles = {}, disabled = false, tabIndex="0" }) => {

    return (
        <>
            <div className={`custom-checkbox ${checked ? '' : 'unchecked'} ${!checked && disabled ? 'unchecked-disabled-styles' : ''}`} style={{ ...styles.checkboxContainer, ...containerStyles, ...(disabled ? styles.disabledCheckedStyle : {}) }}>

                <input name={name} type="checkbox" checked={checked} onChange={onChangeCb} style={styles.checkBoxInput} disabled={disabled} tabIndex={tabIndex} />

                <Icons iconName={iconName} familyName={"vec"} style={styles.checkmark} />

            </div>
        </>
    );
}

export default Checkbox